import { apiGet, buildApiURL } from '@src/services/api';

const getTraining = (id) => {
    return apiGet(buildApiURL(`/api/v1/trainings/${id}`));
};

const getTrainings = (search) => {
    return apiGet(buildApiURL('/api/v1/trainings', search));
};

export {
    getTraining,
    getTrainings,
};
